import React, { useMemo } from 'react';
import classNames from 'classnames';
import { Checkbox } from 'antd';

import style from './styles.scss';
import { getCategoryLabel } from '../../../common/utils';

const NonEditableSetsComp = ({ typologyData, liveSets }) => {
  const categories = useMemo(() => {
    return typologyData.categories?.map((data, i) => {
      return <div className={style.tableText}>{getCategoryLabel(data)}</div>;
    });
  }, [typologyData]);

  return (
    <div className={style.flexTable}>
      <div className={style.seletedSetsView}>
        {typologyData?.combinations?.filter((f) => f.id !== -1).length > 0 ? (
          <>
            <div className={classNames(style.selectedHeaderAll)}>
              <p className={style.headerCheck}>
                <Checkbox checked disabled />
              </p>
              {categories}
            </div>
            {typologyData?.combinations
              ?.filter((f) => f.id !== -1)
              .map((combination) => {
                return (
                  <div className={style.DynamicSelects} key={combination.id}>
                    <p
                      className={style.headerCheck}
                      style={{ paddingLeft: '19px' }}>
                      <Checkbox checked disabled />
                    </p>
                    {combination.entries.map((values, i) => {
                      return (
                        <div key={`t-${i}`} className={style.tableText}>
                          {values.value}
                        </div>
                      );
                    })}
                  </div>
                );
              })}
          </>
        ) : (
          <div className={style.noSetsAvailable}>
            {liveSets?.data?.combinations?.length > 0
              ? `No Segment Set mapped, typology would be applicable to the remaining customers, except these sets`
              : `No Segment Set Available, typology would be applicable to the entire universe of customers`}
          </div>
        )}
      </div>
    </div>
  );
};

export default NonEditableSetsComp;
